import { DEFAULT_STADIUM_CAPACITY } from "../../common/constants.ts";
import teamInfos from "../../common/teamInfos.ts";

export const newLeagueGodModeLimits = () => {
	const pop = Math.max(...Object.values(teamInfos).map((t) => t.pop));

	return {
		pop,
		stadiumCapacity: DEFAULT_STADIUM_CAPACITY,
	};
};
